import { useCallback, useEffect } from "react";
import type * as React from "react";
import { Box } from "@mui/material";
import { useHistory } from "react-router-dom";
import { Model } from "survey-core";
import StandaloneSurveyPageLayout from "components/v3/layouts/StandaloneSurveyPageLayout";
import CologuardPersonalizedResourcesSurvey from "components/v3/sharedComponents/surveys/CologuardPersonalizedResourcesSurvey";
import { COLORS } from "components/v3/Theme/colors";
import { PATHS } from "constants/pathConstants";
import { didMemberRequestNavigatorCallback } from "utils/v3/nextMoveUtils";

const cologuardPersonalizedResourcesSurveyScopeSx = {
  "& .sd-question__title": {
    color: COLORS.BLACK,
    fontWeight: 600
  },
  "& .sd-question__description": {
    color: COLORS.DARK_GRAY,
    marginBottom: "12px"
  }
} as const;

const CologuardPersonalizedResourcesPage: React.FC = () => {
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleComplete = useCallback(
    (surveyModel: Model) => {
      history.push(
        didMemberRequestNavigatorCallback(surveyModel.data)
          ? PATHS.NAVIGATOR_REQUEST_CONFIRMATION
          : PATHS.HELP_CENTER_ROOT
      );
    },
    [history]
  );

  return (
    <StandaloneSurveyPageLayout
      maxWidth={840}
      pageTitle="Learning resources"
    >
      <Box
        className="cologuard-personalized-resources-survey-scope"
        sx={{
          ...cologuardPersonalizedResourcesSurveyScopeSx,
          boxSizing: "border-box",
          display: "flex",
          flex: "1 1 0%",
          flexDirection: "column",
          minHeight: 0,
          overflow: "hidden",
          p: { md: 4, xs: 2.5 },
          width: "100%"
        }}
      >
        <CologuardPersonalizedResourcesSurvey onComplete={handleComplete} />
      </Box>
    </StandaloneSurveyPageLayout>
  );
};

export default CologuardPersonalizedResourcesPage;
